// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { circleX16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-circle-x': IconCircleX;
    }
}

/**
 * The icon component for the 'circleX' icon
 */
export class IconCircleX extends IconSvg {
    public constructor() {
        super(circleX16X16);
    }
}

registerIconSvg('icon-circle-x', IconCircleX);
export const iconCircleXTag = 'nimble-icon-circle-x';
